import { render, staticRenderFns } from "./RecentlyVisitedList.vue?vue&type=template&id=ebdd56fc&scoped=true&"
import script from "./RecentlyVisitedList.vue?vue&type=script&lang=js&"
export * from "./RecentlyVisitedList.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyVisitedList.vue?vue&type=style&index=0&id=ebdd56fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdd56fc",
  null
  
)

export default component.exports